<template>
	<div>
		<h1>code.</h1>
		<div class="box" v-for="project in state.projects" :key="project.id">
			<a :href="project.link" target="_blank"><img :src="require(`../assets/images/projects/${project.image}`)"></a>
		</div>
	</div>
</template>

<script>
import { onMounted, reactive } from 'vue';
import projectService from '../services/ProjectDataService';

export default {
	name: 'Code',
	setup() {

		const state = reactive({
			projects: []
		})

		onMounted(() => {
			console.log('Calling project Api')
			projectService.getAll().then(res => {
				state.projects = res.data.Items;
				console.log(res)
			}).catch(err => console.log(err))
			console.log('Api called')
		})

		return {
			state
		}
	}
}
</script>

<style scoped>

.box {
	display: inline-block;
	border: solid white;
	border-radius: 10pt;
	margin: 10pt;
	width: 350pt;
	max-height: 300pt;
	overflow: hidden;
	position: relative;
	transition: .5s;
}

img {
	max-width: 100%;
	max-height: 100%;
	display: block
}

.box:hover {
	width: 375pt;
	max-height: 325pt;
}

@media (max-width: 1000pt) {
	.box {
		width: 90%;
	}
}

</style>